import React from "react";
import AnchorPointGrid from "./grid";
import AnchorPointMap from "./map";
import { withStyles } from "@material-ui/core";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import AddUpdateAnchorPoint from "./addUpdateAnchorPoint";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import Events from "../../../../../utilities/EventEmitter";

const styles = {
  anchorPointSubModule: {
    height: "100%",
    display: "flex",
    "&>div": {
      width: "50%",
      boxSizing: "border-box",
    },
    "&>.addUpdateAnchorPointForm": {
      width: "15%",
    },
  },
};
@inject("CommonStore")
@observer
class AnchorPoint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnchorPoints: null,
      errorMessage: null,
      zoneInfo: null,
      isAddUpdateAnchorPointFormOpen: false,
      anchorPointsInfo: null,
      anchorPointsPosition: null,
    };
    this.userProfileData = {
      terminal: this.props.userData.userProfile.terminal.code,
      userName: this.props.userData.userProfile.userName,
      planDate: this.props.userData.userProfile.planDate,
    };
  }

  anchorPointClickedOnMap = (anchorPoint) => {
    if (!this.state.isAddUpdateAnchorPointFormOpen) {
      this.setState({
        selectedAnchorPoints: anchorPoint ? [anchorPoint.data] : null,
        zoneInfo: null,
      });
    }
  };

  anchorPointSelectedOnGrid = (anchorPoints) => {
    this.setState({
      selectedAnchorPoints: anchorPoints ? anchorPoints : null,
      zoneInfo:
        anchorPoints && anchorPoints.length ? null : this.state.zoneInfo,
    });
  };

  onDataUpdated = () => {
    // force rerender when store is not refreshed but data is updated
    this.forceUpdate();
  };
  updateAnchorPointDataInStore = () => {
    getDataWithQueryString(
      "GetAnchorPoints",
      `scenarioId=${this.props.userData.userProfile.scenarioID}`
    ).then((response) => {
      if (response.status === 200) {
        this.props.CommonStore.updateAnchorPointsData(response.data);
        Events.emit("RefreshIBStore");
      } else {
        this.props.CommonStore.updateAnchorPointsData([]);
      }
    });
  };
  addUpdateAnchorPointClose = () => {
    this.setState({
      isAddUpdateAnchorPointFormOpen: false,
      anchorPointsInfo: null,
      anchorPointsPosition: null,
    });
  };
  addAnchorPointOpen = () => {
    this.setState({
      isAddUpdateAnchorPointFormOpen: true,
      anchorPointsInfo: null,
      selectedAnchorPoints: [],
      anchorPointsPosition: null,
    });
  };
  updateAnchorPointOpen = () => {
    this.setState({
      isAddUpdateAnchorPointFormOpen: true,
      anchorPointsInfo: this.state.selectedAnchorPoints[0],
    });
  };
  anchorPointsPositionChange = (anchorPointsPosition) => {
    if (
      anchorPointsPosition?.latitude !==
        this.state.anchorPointsPosition?.latitude &&
      anchorPointsPosition?.longitude !==
        this.state.anchorPointsPosition?.longitude
    ) {
      this.setState({
        anchorPointsPosition: anchorPointsPosition,
      });
    }
  };
  onZoneClicked = (zoneInfo) => {
    this.setState({
      selectedAnchorPoints: null,
      zoneInfo,
    });
  };

  render() {
    const { classes } = this.props;
    const { errorMessage, selectedAnchorPoints, zoneInfo } = this.state;
    const anchorPointData = this.props.CommonStore.anchorPointData
      ? this.props.CommonStore.anchorPointData.slice()
      : [];
    const selectedAnchorPoint =
      selectedAnchorPoints &&
      selectedAnchorPoints.map((anchorPoint) => {
        return anchorPoint.anchorPointName;
      });

    return (
      <div className={classes.anchorPointSubModule}>
        <AnchorPointGrid
          data={anchorPointData}
          error={errorMessage}
          selectedAnchorPoints={selectedAnchorPoint}
          anchorPointSelectedOnGrid={this.anchorPointSelectedOnGrid}
          onDataUpdated={this.onDataUpdated}
          scenarioId={this.props.userData.userProfile.scenarioID}
          userProfile={this.userProfileData}
          addAnchorPointOpen={this.addAnchorPointOpen}
          updateAnchorPointOpen={this.updateAnchorPointOpen}
          updateAnchorPointDataInStore={this.updateAnchorPointDataInStore}
          isAddUpdateAnchorPointFormOpen={
            this.state.isAddUpdateAnchorPointFormOpen
          }
          anchorPointsInfo={this.state.anchorPointsInfo}
        />
        <AnchorPointMap
          data={anchorPointData}
          onTerminalChange={this.onTerminalChange}
          onAnchorPointClicked={this.anchorPointClickedOnMap}
          selectedAnchorPoints={selectedAnchorPoint}
          zoneInfo={zoneInfo}
          onZoneClicked={this.onZoneClicked}
          isAddUpdateAnchorPointFormOpen={
            this.state.isAddUpdateAnchorPointFormOpen
          }
          anchorPointsInfo={this.state.anchorPointsInfo}
          anchorPointsPosition={this.state.anchorPointsPosition}
          anchorPointsPositionChange={this.anchorPointsPositionChange}
          userData={this.props.userData}
        />
        {this.state.isAddUpdateAnchorPointFormOpen ? (
          <AddUpdateAnchorPoint
            data={anchorPointData}
            onClose={this.addUpdateAnchorPointClose}
            anchorPointsInfo={this.state.anchorPointsInfo}
            scenarioId={this.props.userData.userProfile.scenarioID}
            anchorPointsPosition={this.state.anchorPointsPosition}
            anchorPointsPositionChange={this.anchorPointsPositionChange}
            updateAnchorPointDataInStore={this.updateAnchorPointDataInStore}
          />
        ) : null}
      </div>
    );
  }
}
export default compose(withStyles(styles), withUserProfile)(AnchorPoint);
